export const CRM_EMBED_MESSAGES = Object.freeze({
  READY: 'CR_READY',
  TOKEN: 'CRM_SSO_TOKEN',
  ACK: 'CR_ACK',
  AUTH_ERROR: 'CR_AUTH_ERROR',
});

const originFromUrl = (value) => {
  if (!value) return null;
  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
};

export const allowedParentOrigins = (configuredOrigins) => {
  return [...new Set((configuredOrigins || '')
    .split(',')
    .map((value) => originFromUrl(value.trim()))
    .filter(Boolean))];
};

export const trustedParentOrigin = ({ referrer, allowedOrigins }) => {
  const referrerOrigin = originFromUrl(referrer);
  return referrerOrigin && allowedOrigins.includes(referrerOrigin) ? referrerOrigin : null;
};

export const isTrustedParentMessage = ({ event, parentWindow, allowedOrigins }) => {
  return Boolean(
    event &&
    parentWindow &&
    event.source === parentWindow &&
    allowedOrigins.includes(event.origin)
  );
};

export const crmAuthErrorCode = (error) => {
  return (
    error?.response?.data?.error ||
    error?.code ||
    error?.message ||
    'crm_auth_failed'
  );
};
